import React from 'react';
import { Link } from 'react-router-dom';
import About1 from "../../assets/img/features/Nosotros_HLF_new4.webp";

function Most() {
  return (
    <>
      <section className="about-area about-p pt-120 pb-120 p-relative fix">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="about-img-container">
                <img src={About1} alt="Hotel La Finca" className="about-img-full" />
              </div>
            </div>

            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="about-content s-about-content wow fadeInRight animated pl-30" data-animation="fadeInRight" data-delay=".4s">
                <div className="about-title second-title pb-25">
                  <h5>Nosotros</h5>
                  <h2>Hotel La Finca por Zotoluca</h2>
                </div>
                <p>
                  Somos un proyecto nacido de la visión de Hacienda Zotoluca,
                  combinando su riqueza histórica con un enfoque innovador en hospitalidad. Inspirado en la
                  arquitectura y el legado colonial de la hacienda, La Finca rescata sus elementos distintivos
                  y los fusiona con un diseño moderno, creando un espacio único que rinde homenaje a la
                  identidad cultural de la región.
                </p>
                <p>
                  Más que un hotel, La Finca representa una evolución en la experiencia de hospedaje,
                  ofreciendo comodidad, elegancia y un ambiente que refleja la esencia de la altiplanicie
                  pulquera.
                </p>
                <div className="about-content3 mt-30">
                  <div className="row justify-content-center align-items-center">
                    <div className="col-md-12">
                      <div className="mb-30">
                        <p style={{ fontSize: "1.2rem", fontStyle: "italic", color: "#9e7b4f", margin: "2rem 0" }}>
                          "Este proyecto busca innovar en el sector, brindando un nuevo concepto de alojamiento que
                          integra tradición, vanguardia y excelencia en el servicio."
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="slider-btn">
                        <Link to="/about" className="btn ss-btn smoth-scroll">Ver Más</Link>
                      </div>
                    </div>
                    <div className="col-md-6 text-right" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Estilos CSS internos */}
      <style jsx>{`
        .about-img-container {
          width: 100%;
        }

        .about-img-full {
          width: 100%;
          height: auto;
          display: block;
        }

        @media (max-width: 768px) {
          .about-img-container {
            margin-bottom: 2rem;
          }
        }
      `}</style>
    </>
  );
}

export default Most;
